import { motion } from 'framer-motion';
import Container from './Container';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';
import { principles } from '@/lib/content';

export default function Principles() {
  return (
    <section
      aria-label="Principles"
      className="relative border-t border-ink/10 bg-paper-50 py-20 md:py-28"
    >
      <Container>
        <motion.ul
          variants={stagger(0.1, 0.1)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-12"
        >
          {principles.map((p, idx) => (
            <motion.li key={p.label} variants={fadeUp} className="relative pl-6">
              <span
                aria-hidden
                className="absolute left-0 top-1.5 font-mono text-[0.7rem] tracking-[0.2em] text-copper"
              >
                0{idx + 1}
              </span>
              <h3 className="font-display text-xl md:text-2xl">{p.label}</h3>
              <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-ink/70">{p.body}</p>
            </motion.li>
          ))}
        </motion.ul>
      </Container>
    </section>
  );
}
